import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import classNames from 'classnames';
import BulbIcon from '../../../MUI/Icons/BulbIcon';
import MainButton from '../../../MUI/MainButton';
import InfoIcon from '../../../MUI/Icons/InfoIcon';
import GeorgiaSpecialPriceAlert from '../GeorgiaSpecialPriceAlert';
import useDeviceResize from '../../../../hooks/useDeviceResize';
import { PACKAGES } from '../../../../constants/travelCalcConstants';

import useStyles from '../makeStyles';

const OpenDates = ({
  selectedPackage,
  setSelectedPackage,
  range,
  updateDatesOnDayChange,
  updateDatesAccordingPackage,
  hasOnlyLiteDisallowedCountry,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [openPackages, setOpenPackages] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const isDeviceMobileSize = useDeviceResize('sm');

  useEffect(() => {
    setShowAlert(hasOnlyLiteDisallowedCountry);
  },
  [hasOnlyLiteDisallowedCountry]);

  const handlePackageChange = (newPackage) => {
    if (!newPackage || selectedPackage.value === newPackage.value) {
      setSelectedPackage({});
      updateDatesOnDayChange(selectedPackage.value);
    } else {
      setSelectedPackage(newPackage);
      updateDatesAccordingPackage(newPackage, range.start);
    }
  };

  return (
    <>
      {showAlert && (
        <GeorgiaSpecialPriceAlert
          selectedPackage={selectedPackage}
          setSelectedPackage={setSelectedPackage}
          handlePackageChange={handlePackageChange}
          setShowAlert={setShowAlert}
        />
      )}
      <Grid container alignItems="center" justifyContent="center" className={classes.container}>
        <Grid item>
          <BulbIcon width="1.5rem" height="1.5rem" />
        </Grid>
        <Grid item xs={10}>
          <Typography
            className={classes.packageDesktopText}
            style={{
              fontSize: isDeviceMobileSize ? 12 : 16,
              paddingLeft: isDeviceMobileSize ? 5 : 20,
            }}
          >
            {t('travel.packageText')}
          </Typography>
        </Grid>
        <Grid item xs={1} className={classes.headingWrapper}>
          <IconButton
            style={{ transform: openPackages ? 'rotate(180deg)' : 'rotate(90deg)' }}
            onClick={() => setOpenPackages(!openPackages)}
            className={classes.iconButton}
          >
            <ExpandLessIcon />
          </IconButton>
        </Grid>
        <Grid
          container
          item
          xs={12}
          className={classNames(classes.buttonsWrapper, {
            [classes.buttonsWrapperOpen]: openPackages,
          })}
          style={{ paddingLeft: isDeviceMobileSize ? 0 : 58 }}
        >
          {PACKAGES.map((item) => (
            <Grid item key={`p${item.value}`} xs={12} sm={4} className={classes.gridItem}>
              <MainButton
                color="primary"
                className={classNames(classes.mainButton, {
                  [classes.active]: selectedPackage.value === item.value,
                })}
                variant={selectedPackage.value === item.value ? 'contained' : 'outlined'}
                onClick={() => handlePackageChange(item)}
                style={{
                  fontSize: isDeviceMobileSize ? 12 : 14,
                  width: 210,
                }}
              >
                {t(item.month ? 'travel.packageLabelMonth' : 'travel.packageLabelYear', item)}
              </MainButton>
            </Grid>
          ))}
        </Grid>
      </Grid>
      {selectedPackage.value && (
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classNames(classes.textContainer, {
            [classes.textContainerOpen]: openPackages,
          })}
        >
          <Grid item>
            <InfoIcon width="1.5rem" height="1.5rem" />
          </Grid>
          <Grid item xs={11}>
            <Typography
              className={classes.text}
              style={{
                fontSize: isDeviceMobileSize ? 12 : 14,
                paddingLeft: isDeviceMobileSize ? 10 : 20,
              }}
            >
              {t(
                selectedPackage.month ? 'travel.packageInfoMonth' : 'travel.packageInfoYear',
                selectedPackage,
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};

OpenDates.propTypes = {
  range: PropTypes.shape({
    start: PropTypes.instanceOf(Date),
    end: PropTypes.instanceOf(Date),
  }),
  selectedPackage: PropTypes.shape({
    value: PropTypes.number,
    month: PropTypes.number,
    year: PropTypes.number,
  }),
  setSelectedPackage: PropTypes.func.isRequired,
  updateDatesAccordingPackage: PropTypes.func.isRequired,
  updateDatesOnDayChange: PropTypes.func.isRequired,
  hasOnlyLiteDisallowedCountry: PropTypes.bool.isRequired,
};

OpenDates.defaultProps = {
  range: {},
  selectedPackage: {},
};

export default OpenDates;
